import React from "react";
import Image from "assets/images/solutionTrade2.svg"; 
import { LOCALE_STRINGS } from "constants/locales";

const CheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="checklist-item__icon"
  >
    <path
      d="M20 6L9 17L4 12"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FeatureListSection = ({
  imageSrc = Image,
  language = "EN",
}) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};


  const checklistItems = [
    strings.feature_check_1 || "Automated contract generation and tracking",
    strings.feature_check_2 || "Real-time shipment and logistics visibility",
    strings.feature_check_3 || "Pre-vetted suppliers across global markets",
    strings.feature_check_4 || "One counterparty, one point of accountability",
  ];

  return (
    <section className="feature-list-section">
      <div className="feature-list">
        
        <div className="feature-content">
          
          <div className="text-block">
            <h2 className="text-block__title">
              {strings.feature_list_title ||
                "The paperwork and the port both move without you"}
            </h2>
            <p className="text-block__description">
              {strings.feature_list_desc ||
                "Once an order is placed, Ezer's systems take over the parts that used to eat a week of back-and-forth: contracts are generated and tracked automatically, and every shipment is visible in real time from origin to your door"}
            </p>
          </div>

          <div className="checklist">
            {/* Ряд 1 */}
            <div className="checklist-row">
              <div className="checklist-item">
                <CheckIcon />
                <span className="checklist-item__text">{checklistItems[0]}</span>
              </div>
              <div className="checklist-item">
                <CheckIcon />
                <span className="checklist-item__text">{checklistItems[1]}</span>
              </div>
            </div>

            {/* Ряд 2 */}
            <div className="checklist-row">
              <div className="checklist-item">
                <CheckIcon />
                <span className="checklist-item__text">{checklistItems[2]}</span>
              </div>
              <div className="checklist-item">
                <CheckIcon />
                <span className="checklist-item__text">{checklistItems[3]}</span>
              </div>
            </div>
          </div>

        </div>

        <div className="feature-image-wrapper">
          <img
            src={imageSrc}
            alt="Logistics and shipment"
            className="feature-image"
          />
        </div>

      </div>
    </section>
  );
};